export function parseMetricIntegerExpression(s) {
  let quantity=null;
  if(s) {
    let parts=s.split(/(-?[0-9]+)/);
    let units=null;
    parts.forEach((part) => {
      if((typeof part)==='string') {
        if(part.length>0) {
          let test=parseInt(part,10);
          if(!isNaN(test)) {
            quantity=parseInt(part,10);
          } else {
            units=part.toUpperCase();
          }         
        }
      }
    });
    if(quantity!==null) {
      if(units==='K') {
        quantity=quantity*1024;
      } else if(units==='M') {
        quantity=quantity*Math.pow(1024,2);
      } else if(units==='G') {
        quantity=quantity*Math.pow(1024,3);
      } else if(units==='T') {
        quantity=quantity*Math.pow(1024,4);
      }
    }
    //console.log("PARSED: ",quantity,units)
  }
  return quantity;
}

